var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "request-list-page" }, [
    _c("header", { staticClass: "request-list-toolbar" }, [
      _c(
        "button",
        {
          staticClass: "new-request-action",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.newTicket()
            }
          }
        },
        [
          _c("portal-icon", { attrs: { name: "plus", size: 17 } }),
          _vm._v(" " + _vm._s(_vm.$t("requests.new-request")) + " ")
        ],
        1
      )
    ]),
    _c("div", { staticClass: "request-list-content show-scrollbar" }, [
      _c(
        "div",
        { staticClass: "request-table-shell portal-compact-list-shell" },
        [
          _vm.isReady
            ? _c("v-data-table", {
                staticClass: "request-table portal-compact-table",
                staticStyle: { cursor: "pointer" },
                attrs: {
                  headers: _vm.headers,
                  "sort-by": "updated",
                  "sort-desc": true,
                  "must-sort": true,
                  items: _vm.filteredTickets,
                  "disable-pagination": true,
                  "hide-default-footer": true,
                  "mobile-breakpoint": 200,
                  "no-data-text": _vm.$t("requests.no-found-requests")
                },
                on: {
                  "click:row": function($event) {
                    return _vm.viewTicketDetail($event)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.status",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "div",
                            { staticClass: "row-format align-center" },
                            [
                              item.unreadClient
                                ? _c("div", { staticClass: "umi mr-2" })
                                : _vm._e(),
                              item.open
                                ? _c(
                                    "portal-status-pill",
                                    {
                                      attrs: {
                                        background: _vm.ticketStatusBackground(
                                          item,
                                          _vm.ticketTypes
                                        ),
                                        color: "var(--portal-text)"
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(item.status) + " ")]
                                  )
                                : _c(
                                    "portal-status-pill",
                                    {
                                      attrs: {
                                        background: "var(--v-alert_10-base)",
                                        color: "var(--v-alert-base)"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("requests.closed")) +
                                          " "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        ]
                      }
                    },
                    {
                      key: "item.type",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _vm.getTicketType(item.type)
                            ? _c(
                                "span",
                                {
                                  staticClass: "portal-cell-truncate",
                                  attrs: {
                                    title: _vm.getTicketType(item.type).type
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getTicketType(item.type).type
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _c("span", { staticClass: "portal-cell-muted" }, [
                                _vm._v("—")
                              ])
                        ]
                      }
                    },
                    {
                      key: "item.updated",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "portal-cell-truncate portal-cell-muted",
                              attrs: {
                                title: _vm.DateTime.fromISO(
                                  item.updated
                                ).toLocaleString(_vm.DateTime.DATETIME_MED)
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.DateTime.fromISO(item.updated).toFormat(
                                      "MMM d, yyyy"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.subject",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "portal-cell-truncate portal-cell-primary",
                              attrs: { title: item.subject }
                            },
                            [_vm._v(" " + _vm._s(item.subject) + " ")]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.lastComment",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c("div", {
                            staticClass:
                              "portal-cell-truncate portal-cell-muted",
                            attrs: { title: _vm.plainText(item.lastComment) },
                            domProps: { innerHTML: _vm._s(item.lastComment) }
                          })
                        ]
                      }
                    },
                    {
                      key: "no-data",
                      fn: function() {
                        return [
                          _c("div", { staticClass: "request-empty" }, [
                            _c(
                              "span",
                              { staticClass: "request-empty-icon" },
                              [
                                _c("portal-icon", {
                                  attrs: { name: "ticket", size: 21 }
                                })
                              ],
                              1
                            ),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("requests.no-found-requests"))
                              )
                            ])
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  793930206
                )
              })
            : _c(
                "div",
                { staticClass: "request-list-loading" },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      size: 34,
                      width: 3,
                      color: "primary"
                    }
                  })
                ],
                1
              )
        ],
        1
      ),
      _vm.isReady && _vm.closedTicketCount
        ? _c(
            "button",
            {
              staticClass: "closed-request-toggle",
              attrs: {
                type: "button",
                "aria-expanded": _vm.showClosedTickets ? "true" : "false"
              },
              on: { click: _vm.toggleClosedTickets }
            },
            [
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.showClosedTickets
                        ? _vm.$t("requests.list.hide")
                        : _vm.$t("requests.list.show")
                    ) +
                    " " +
                    _vm._s(_vm.closedTicketCount) +
                    " " +
                    _vm._s(_vm.$t("requests.list.closed")) +
                    " "
                )
              ]),
              _c("portal-icon", {
                attrs: {
                  name: _vm.showClosedTickets ? "chevron-up" : "chevron-down",
                  size: 16
                }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }